import { useTranslation } from 'react-i18next';
import { PreviewService } from 'core/api/services/preview';
import { Grid2 } from '@mui/material';
import { MoneyFormattedUtils, PreviewPriceGroup } from '@utriper/core-ui';
import CapacityIcon from 'assets/icons/capacity.svg';

// TODO: Improve this component to make it more legible, or improve how these bubbles appear on the calendar.
const EventContent = ({ eventInfo }) => {
    const { t: translate } = useTranslation();
    if (eventInfo.timeText.endsWith('- 23:59')) {
        eventInfo.timeText = eventInfo.timeText.replace('- 23:59', '- 00:00');
    } else if (eventInfo.timeText.endsWith('- 0')) {
        eventInfo.timeText = eventInfo.timeText.replace('- 0', '- 00:00');
    }

    const event = eventInfo?.event?.extendedProps;
    const hasPriceGroup = Number.isInteger(event?.priceGroupId) && event?.priceGroupId > 0;

    return (
        <Grid2
            container
            flexDirection="column"
            flexWrap="nowrap"
            sx={{
                padding: '6px',
                flexDirection: 'column',
                height: '100%',
                overflowY: 'auto',
                // Custom scrollbar styles
                '&::-webkit-scrollbar': {
                    width: '4px',
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    borderRadius: '2px',
                },
                fontWeight: 600,
                gap: '4px',
            }}
        >
            <Grid2>{hasPriceGroup ? <PreviewPriceGroup id={event.priceGroupId} label="name" previewService={PreviewService} styles={{ color: '#fff !important' }} route={`/price-group/${event.priceGroupId}`} /> : `${event?.currency} ${MoneyFormattedUtils(event?.price)}`}</Grid2>
            <Grid2>
                <img src={CapacityIcon} alt="capacity" width={20} style={{ marginRight: 5 }} />
                {event?.unlimited ? translate('experience_calendar.event_content.unlimited') : event?.capacity} {event?.privateSlot ? 'priv' : ''}
            </Grid2>
            <Grid2>
                <span>{eventInfo.timeText}</span>
            </Grid2>
        </Grid2>
    );
};

export default EventContent;
